/* eslint-disable quotes */
import { crud } from "../db/indexeddb.service";
import { getMiniGuidesDB, MINIGUIDES_STORE } from "../db/mini-guides.db";

// By convention, id = -1 is used for the temporary draft
const TEMP_ID = -1;

const MiniGuidesLocalService = {
  async saveById(id, miniGuide, langs, paragraphs, glossaries, questions, alert) {
    const db = await getMiniGuidesDB();
    return crud.put(db, MINIGUIDES_STORE, {
      id: id,
      miniGuide,
      langs,
      paragraphs,
      glossaries,
      questions,
      alert,
    });
  },

  async getById(id) {
    const db = await getMiniGuidesDB();
    return crud.get(db, MINIGUIDES_STORE, id);
  },

  async deleteById(id) {
    const db = await getMiniGuidesDB();
    return crud.delete(db, MINIGUIDES_STORE, id);
  },

  // Saves/updates a temporary draft.
  async saveTemp(miniGuide, langs, paragraphs, glossaries, questions, alert) {
    return this.saveById(TEMP_ID, miniGuide, langs, paragraphs, glossaries, questions, alert);
  },

  // Gets the temporary draft (-1)
  async getTemp() {
    return this.getById(TEMP_ID);
  },

  // Deletes the temporary draft (-1)
  async deleteTemp() {
    return this.deleteById(TEMP_ID);
  },
};

export default MiniGuidesLocalService;
